/**
 * Step 16 — Push permission picker (conditional on step 15)
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 16
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import PushPermissionSynthesis from './PushPermission.synthesis'

export const NOTIFICATION_TOGGLES = [
  {
    key: 'daily_scripture',
    label: 'Daily Scripture',
    desc: 'One verse, one thought, one question to carry into your day',
    defaultOn: true,
    icon: '📖',
  },
  {
    key: 'streak_nudge',
    label: 'Streak nudge',
    desc: "If you miss a day. Just one. Won't shame you.",
    defaultOn: true,
    icon: '🔥',
  },
  {
    key: 'ministry_map',
    label: 'Ministry Map reminder',
    desc: 'Weekly nudge to pray for someone in your circle',
    defaultOn: true,
    icon: '🙏',
  },
  {
    key: 'lessons',
    label: 'Lesson reminder',
    desc: 'When your next Learn lesson is ready',
    defaultOn: false,
    icon: '🎓',
  },
  {
    key: 'founder',
    label: 'Founder updates',
    desc: 'Rare. Only when something matters.',
    defaultOn: false,
    icon: '✨',
  },
]

export default function PushPermissionStep({ preferences, onToggle, onAllow, onSkip }) {
  return (
    <PushPermissionSynthesis
      preferences={preferences || {}}
      onToggle={onToggle}
      onAllow={onAllow}
      onSkip={onSkip}
      toggles={NOTIFICATION_TOGGLES}
    />
  )
}
